
function lockFocus(modalID) {

    $('#modalID').addEventListener('transitionend', (e) => {
        $('#modalID').querySelector('input').focus();
    });
}